const RoutesAdminDashboard = React.lazy(() => import("routes/admin/dashboard-route"))
const RoutesUserDashboard = React.lazy(() => import("routes/user/dashboard-route"))
const UsersSignIn = React.lazy(() => import("components/users/sign-in"))

export default memo(shapeComponent(class RoutesFrontWelcome extends ShapeComponent {
  render() {
    setLayout("front")

    const currentUser = useCurrentUser()

    if (isUserA(currentUser, "admin")) {
      return <RoutesAdminDashboard />
    } else if (isUserA(currentUser, "student")) {
      return (
        <FrontLayout className="routes--front--welcome">
          <UsersSignIn redirectAfterSignIn />
        </FrontLayout>
      )
    } else if (isUserA(currentUser, "teacher")) {
      return <RoutesUserDashboard />
    } else {
      return (
        <div className="align-center" style={{width: "100%", height: "100%"}}>
          <div className="routes--front--welcome">
            <UsersSignIn redirectAfterSignIn />
          </div>
        </div>
      )
    }
  }
}))
